import { useEffect, useRef } from "react"
import { useDispatch } from "react-redux"
import { updateHeader } from "../../slices/header-slice";
import { useInView } from "framer-motion";

import Animate from '../../components/animate';
import CustomSubmissionForm from '../../components/custom-submission-form';

import './styles.scss';

const Custom = () => {
    const dispatch = useDispatch();

    const ref = useRef(null);
    const isInView = useInView(ref, { once: false, amount: 0.1 });

    useEffect(() => {
        if (isInView) {
            dispatch(updateHeader('transparent'))

        } else {
            dispatch(updateHeader('dark'))
        }
    }, [isInView, dispatch]);

    useEffect(() => {
        dispatch(updateHeader('transparent'))
    }, [dispatch]);

    return (
        <>
            <div className="custom-design">
                <div ref={ref} className="page-hero">
                    <div className="hero-content">
                        <h1>Create your legacy piece</h1>
                        <p>With Paramount Wood Co.</p>
                    </div>
                </div>

                <Animate>
                    <div className="custom-info">
                        <h2>Commission a bespoke heirloom piece, expertly crafted and designed to last generations. Work collaboratively with one of our highly skilled woodworkers, to create a truly unique piece of furniture from initial brief right up to tailored installation.</h2>
                        <p>Register your interest below</p>
                        <div className="line"></div>
                    </div>
                </Animate>

                <Animate>
                    <CustomSubmissionForm />
                </Animate>
            </div>
        </>

    )
}

export default Custom